<template>
  <div class="wrapper">
    <van-dialog v-model="show" :title="$t('other.a1704')">
      <div class="boxImg">
        <img style="width:50%;" src="https://erp.shopsbu.com/img/distore.7857f3f3.jpg" />
      </div>
      <div class="boxImg">
        <div style="font-size:12px;">{{$t('other.a1705')}}</div>
        <div style="font-size:12px;">{{$t('other.a1706')}}：shopsbu007</div>
      </div>
    </van-dialog>
    <div class="itemWrapper" v-for="(item,index) in orderList" :key="index">
      <div class="children" v-for="(children,index01) in item" :key="index01">
        <div class="iconwrapper">
          <div class="icon_item">
            <img style="width:50%" :src="getImgeUrl(children.country)" />
            {{children.groupId}}----{{ index }}
          </div>
          <!-- <span class="icon_desc">{{getConutryName(children.country)}}</span> -->
        </div>
        <div class="picbox" @click="viewItem(children)">
          <img :src="children.image" />
        </div>
        <div class="groupName nambox">{{children.groupName}}</div>
        <div class="groupName">
          {{$t('h5.DSX_index_price')}}:
          <span style="color:red">RMB{{(children.maxPrice).toFixed(2)}}</span>
        </div>
        <div class="groupName">
          {{$t('h5.DSX_index_profit')}}:
          <span style="color:red">{{children.minGrossProfitRate}}~{{children.maxGrossProfitRate}}%</span>
        </div>
        <div class="groupName">{{$t('h5.DSX_index_qty')}}:{{children.amount}}</div>
        <div class="groupName" style="text-align:right;">
          <van-button
            size="mini"
            type="primary"
            style="background-color: rgb(64, 158, 255);border: 1px solid rgb(64, 158, 255)"
            @click="yanpinDia(children)"
          >{{$t('h5.DSX_index_sample')}}</van-button>

          <van-button
            v-if="!children.agency"
            size="mini"
            style="background-color: #2aa515;"
            type="primary"
            @click="distributeItem(children)"
          >{{$t('h5.DSX_index_dropship')}}</van-button>
          <van-button v-if="children.agency" size="mini" type="warning">{{$t('other.a340')}}</van-button>
        </div>
      </div>
    </div>
    <van-loading
      v-show="showLoading"
      style="text-align:center"
      type="spinner"
      color="#1989fa"
    >{{$t('other.a1707')}}</van-loading>
  </div>
</template>

<script>
import api from "../../../api/api";
import newOrders from "../../../api/moudles/newOrders";
import userStoreItems from "../../../api/moudles/userStoreItems";
import utils from "../../../utils/utils";
import { Throttle, debounce } from "../../../utils/toolFun";
export default {
  data() {
    return {
      userId: null,
      show: false,
      areaList: [
        {
          country: "TH",
          label: this.$t('other.a1091'),
          imgUrl:
            "https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/19eab6fe794e4afb9fa1926be6d69fd1.png"
        },
        {
          country: "MY",
          label: this.$t('h5.DSX_index_my'),
          imgUrl:
            "https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/12ef3ca7a7504a46a94bf6cc9c90afdd.png"
        },
        {
          country: "PH",
          label: this.$t('h5.DSX_index_ph'),
          imgUrl:
            "https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/33c5ac8214fe450fa3a9f79792d5cba7.png"
        },
        {
          country: "TW",
          label: this.$t('h5.DSX_index_tw'),
          imgUrl:
            "https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/f384543fc28841409f5a75346b4e9447.png"
        },
        {
          country: "ID",
          label: this.$t('h5.DSX_index_id'),
          imgUrl:
            "https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/245a7cf4081347628838b042479e8c3a.png"
        },
        {
          country: "VN",
          label: this.$t('h5.DSX_index_vn'),
          imgUrl:
            "https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/36312c8bb5064d5c9e8d21eda8ea23e6.png"
        },
        {
          country: "BZ",
          label: this.$t('h5.DSX_index_bz'),
          imgUrl:
            "https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/c71468db1f744cf585a0161dbb2cfda7.png"
        },
        {
          country: "CN",
          label: this.$t('h5.DSX_index_cn'),
          imgUrl:
            "https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/664e760fce604256a502794ffa85df71.jpg"
        }
      ],
      num: 0
    };
  },
  props: {
    country: {
      type: String,
      default: null
    },
    orderList: {
      type: Array,
      default: () => {}
    },
    showLoading: {
      type: Boolean,
      default: true
    }
  },
  watch: {},

  methods: {
    yanpinDia() {
      this.show = true;
    },
    distributeItem(item) {
        this.userId = JSON.parse(localStorage.getItem("userInfo"))
      ? JSON.parse(localStorage.getItem("userInfo")).userId
      : null;
      console.log(item);
      let params = JSON.parse(JSON.stringify(item));
      params.userId = this.userId;
      if (!this.userId) {
        this.$dialog
          .alert({
            message: "user is not logged in, go to login",
            confirmButtonText: "comfirm"
          })
          .then(() => {
            this.$router.push({
              path: "/mh5/login",
              query: {
                invitationCode: this.$route.query.invitationCode
              }
            });
          });
      }
      console.log('params',this.userId)
      api.copyStoreItem(params).then(res => {
        if (res.code === 200) {
          this.$dialog.alert({
            message:
              this.$t('h5.DSX_index_tips'),
            title: this.$t('other.a1708')
          });
          if(res.data.storeItems){
              res.data.storeItems.forEach(p => {
                p.synchrony=true
                this.updataSync(p)
              })
            }
        } else {
          this.$dialog
            .alert({
              message: res.msg,
              title: this.$t('other.a1709')
            })
            
        }
      });
    },
    updataSync(ttp){
      userStoreItems
        .sellerUpdateSynchrony(ttp)
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        }else{
        console.log(res.msg)
        }
        })
    },
    viewItem(item) {
      this.$router.push({
        path: "/mh5/detail",
        query: {
          groupId: item.groupId,
          productId: item.productId,
          invitationCode: this.$route.query.invitationCode,
          country: this.country
        }
      });
    },

    getImgeUrl(url) {
      let ttp = this.areaList.find(item => item.country == url);
      return ttp ? ttp.imgUrl : null;
    },

    getConutryName(id) {
      return utils.getCountryName(id);
    }
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  margin-top: 15px;
  margin-bottom: 90px;
  img {
    width: 100%;
  }

  .boxImg {
    text-align: center;
    margin: 10px 0;
  }

  .itemWrapper {
    width: 100%;
    display: flex;
    justify-content: space-around;
    box-sizing: border-box;
    padding: 0 5px;

    .iconwrapper {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 5px;
    }

    .children {
      width: 47%;
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: #fff;
      margin-bottom: 8px;
      border-radius: 8px;
      font-size: 13px;
      position: relative;

      .icon_item {
        position: absolute;
        top: 5px;
        left: 10px;
        width: 30px;
      }

      .icon_desc {
        position: absolute;
        top: 5px;
        left: 30px;
      }

      .groupName {
        width: 100%;
        margin: 5px 0;
        box-sizing: border-box;
        padding: 2px 8px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .nambox {
        height: 37px;
      }
    }
  }

  .picbox {
    margin: 1.5rem 0 0.8rem 0;
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    overflow: hidden;
  }
}
</style>